/* eslint-disable camelcase */

import EnvironmentService from './../services/environmentService';

const EMEA = 'EMEA';

const TRIP_RATINGS_BASE = {
    [EMEA]: {
        LOCAL: 'http://localhost:42042/api/',
        TEST: 'https://odm-rating-service.test.odm.bmw-fleet.net/',
        INT: 'https://odm-rating-service.int.odm.bmw-fleet.net/',
        PROD: 'https://odm-rating-service.prod.odm.bmw-fleet.net/'
    }
};

const ODM_ROUTING_BASE = {
    [EMEA]: {
        LOCAL: 'http://localhost:42042/api/',
        TEST: 'https://api.odm-routing.test.odm.bmw-fleet.net/v1/odmrouting/',
        INT: 'https://api.odm-routing.int.odm.bmw-fleet.net/v1/odmrouting/',
        PROD: 'https://api.odm-routing.prod.odm.bmw-fleet.net/v1/odmrouting/'
    }
};

const ODM_GEOCODING_BASE = {
    [EMEA]: {
        LOCAL: 'http://localhost:42042/api/',
        TEST: 'https://geocoding-api.test.odm.bmw-fleet.net/',
        INT: 'https://geocoding-api.int.odm.bmw-fleet.net/',
        PROD: 'https://geocoding-api.prod.odm.bmw-fleet.net/'
    }
};

const ODM_FLEETS_MASTER_DATA_BASE = {
    [EMEA]: {
        LOCAL: 'http://localhost:42042/external-fleets-masterdata/',
        TEST: 'https://odm-vehicle-fleet-masterdata-service.test.odm.bmw-fleet.net/',
        INT: 'https://odm-vehicle-fleet-masterdata-service.int.odm.bmw-fleet.net/',
        PROD: 'https://odm-vehicle-fleet-masterdata-service.prod.odm.bmw-fleet.net/'
    }
};

const SERVICE_CONFIGS = [TRIP_RATINGS_BASE, ODM_ROUTING_BASE, ODM_GEOCODING_BASE];

let environment = EnvironmentService.getEnvironment();
let region = EMEA;

function getBase(config) {
    const regionConfig = config[region];
    
    switch (environment) {
        case 'LOCAL':
            return regionConfig.LOCAL || regionConfig.TEST;
        case 'TEST':
            return regionConfig.TEST; // TEST entry needs to be available
        case 'INT':
            return regionConfig.INT || regionConfig.TEST;
        case 'PROD':
            return regionConfig.PROD || regionConfig.INT || regionConfig.TEST;
        default:
            return regionConfig.TEST;
    }
}

function isExternal(url) {
    return SERVICE_CONFIGS.some(serviceConfig => url.includes(getBase(serviceConfig)));
}

export default {
    tripRatings: {
        fetchRatings: getBase(TRIP_RATINGS_BASE) + 'ratings?createdFrom={0}&createdTo={1}'
    },

    odmRouting: {
        getRoute: getBase(ODM_ROUTING_BASE) + 'route/route?startLat={0}&startLon={1}&destLat={2}&destLon={3}&outFormats={4}&fleetId={5}&componentName={6}'
    },

    geoCoding: {
        geocode: getBase(ODM_GEOCODING_BASE) + 'geocode/{0}/?address={1}',
        reverse: getBase(ODM_GEOCODING_BASE) + 'reverse/{0}/?lat={1}&lon={2}'
    },
    
    fleetsMasterData: {
        getFleetsMasterData: getBase(ODM_FLEETS_MASTER_DATA_BASE) + 'fleets',
        getOperators: getBase(ODM_FLEETS_MASTER_DATA_BASE) + 'operators',
        getSubsidiaries: getBase(ODM_FLEETS_MASTER_DATA_BASE) + 'subsidiaries'
    },

    isExternal: isExternal,

    // Just for testing!
    __getBase: getBase,
    __setEnvironment(env) {
        environment = env;
    },
    __setRegion(reg) {
        region = reg;
    }
};